var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNoFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6488_421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.0001,
    rx: 4,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(4 4)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4752 27.3L22.1752 25H9.0002C8.4502 25 7.97936 24.8042 7.5877 24.4125C7.19603 24.0208 7.0002 23.55 7.0002 23V9.82501L4.7002 7.50001L6.1002 6.10001L25.9002 25.9L24.4752 27.3ZM9.0002 23H20.1752L18.1752 21H10.0002L13.0002 17L15.0002 19.725L15.8502 18.675L9.0002 11.825V23ZM25.0002 22.175L23.0002 20.175V9.00001H11.8252L9.8252 7.00001H23.0002C23.5502 7.00001 24.021 7.19584 24.4127 7.58751C24.8044 7.97917 25.0002 8.45001 25.0002 9.00001V22.175Z",
    fill: "#C4CDD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6488_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.0001,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoFavicon);
export default __webpack_public_path__ + "static/media/ico-no-favicon.48081841ee1fc31b4b46a598820e0153.svg";
export { ForwardRef as ReactComponent };